export const CasinoMessageChannels = {
    GetCategories: "GetCategories",
    GetGames: "GetGames",
    GetFreespins: "GetFreespins",
    GetLaunchParams: "GetLaunchParams"
};
//# sourceMappingURL=index.js.map